import { useState } from 'react';

import { FEEDBACK_INITIAL_SORT_STATUS } from '@/configs/filter';
import { usePublic } from '@/contexts/PublicContext';
import useWorkspaceStorage from '@/hooks/pure/useWorkspaceStorage';

export const useFeedbackSortState = () => {
  const isPublic = usePublic();

  const publicState = useState<NotNullableSortStatusT>(
    FEEDBACK_INITIAL_SORT_STATUS,
  );

  try {
    return useWorkspaceStorage<NotNullableSortStatusT>(
      'feedback_list_sort_state',
      FEEDBACK_INITIAL_SORT_STATUS,
    );
  } catch (error) {
    if (isPublic) {
      return publicState;
    }

    console.error('Failed to load feedback sort state:', error);
    throw error;
  }
};
